// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarFeatureList-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarFeatureList.desktop.scss
 ** module id = 894
 ** module chunks = 1
 **/